import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { NavLink, useNavigate } from "react-router-dom/dist";


const PageHeader = ({ heading, tabs }) => {

    const navigate = useNavigate();
    return (
        <>
            <div className="container pagesHeader">
                <div>

                    {/* <FontAwesomeIcon style={{ cursor: "pointer" }} fontSize={20} onClick={() => navigate(-1)} icon={faArrowLeft} /> */}
                    <h1 className="bold">{heading}</h1>
                </div>

                <div>
                    {tabs && tabs.length && tabs.map((e,index) => (
                        <NavLink to={e.route} className="tabs" activeClassName="active">{e.name}</NavLink>

                    ))}
                </div>


            </div>


        </>
    );
};

export default PageHeader;
